"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _invitationSdk = require("@ccx-public/invitation-sdk");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useCapabilities = function useCapabilities(urn, apiKey, environment, invitationServiceAccessToken) {
  var imsData = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

  var _useState = (0, _react.useState)({}),
      _useState2 = _slicedToArray(_useState, 2),
      capabilities = _useState2[0],
      setCapabilities = _useState2[1];

  var token = imsData.token,
      isGuestUser = imsData.isGuestUser;
  var env = environment === 'dev' ? 'stage' : environment;
  (0, _react.useEffect)(function () {
    if (urn && apiKey && env && (token || invitationServiceAccessToken) && !isGuestUser) {
      _invitationSdk.CapabilitiesService.configure({
        token: token,
        environment: env,
        apiKey: apiKey,
        apiVersion: 'v4'
      });

      var capabilitiesInstance = new _invitationSdk.CapabilitiesService();
      capabilitiesInstance.get({
        resourceUrl: urn
      }).then(function (capabilitiesResp) {
        return setCapabilities(capabilitiesResp);
      }).catch(function () {
        return setCapabilities({});
      });
    }
  }, [urn, apiKey, env, invitationServiceAccessToken, token, isGuestUser]);
  return capabilities;
};

var _default = useCapabilities;
exports.default = _default;